import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AssignRoleLayer from "../components/AssignRoleLayer";


const AssignRolePage = () => {
  return (
    <>
    

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Assign Roles  </h5><Breadcrumb title="Assign Role" /></div>

        {/* AssignRoleLayer */}
        <AssignRoleLayer />


    </>
  );
};

export default AssignRolePage;
